import type React from 'react';
import type { MouseEvent } from 'react';

import { Button } from '@cobliteam/ui/components';
import { cn } from '@cobliteam/ui/utils';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import type { PopperPlacementType } from '@material-ui/core/Popper';
import * as styles from './styles';

import { BodyText, DescriptionTitle, Popper, WarningIcon } from '@cobliteam/base-components';

export enum ConfirmationPopperType {
  DEFAULT = 'DEFAULT',
  WARNING = 'WARNING',
}

export interface ConfirmationPopperProps {
  placement: PopperPlacementType;
  title: string;
  bodyText: string;
  isOpen: boolean;
  anchorEl?: HTMLElement | null;
  arrow?: boolean;
  loading?: boolean;
  cancelTitle?: string;
  confirmTitle: string;
  popperType?: ConfirmationPopperType;
  className?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
const ConfirmationPopper: React.FC<ConfirmationPopperProps> = ({
  placement,
  title,
  bodyText,
  isOpen,
  anchorEl,
  arrow = false,
  loading = false,
  cancelTitle = 'Cancelar',
  confirmTitle,
  popperType = ConfirmationPopperType.DEFAULT,
  onConfirm,
  onCancel,
  className,
}) => (
  <Popper arrow={arrow} open={isOpen} anchorEl={anchorEl} placement={placement}>
    <ClickAwayListener onClickAway={onCancel} mouseEvent='onMouseDown'>
      <div className={cn(styles.confirmationPopperBody, className)}>
        <div>
          <div className={styles.titleIcon}>
            <WarningIcon className={styles.closeTitleIcon(popperType)} />
            <DescriptionTitle> {title} </DescriptionTitle>
          </div>
          <BodyText className={styles.closeText}> {bodyText} </BodyText>

          <div className={styles.closeActions}>
            <Button
              variant='text'
              disabled={loading}
              className='p-0'
              onClick={(event: MouseEvent<HTMLButtonElement>) => {
                onCancel();
                event.stopPropagation();
              }}
            >
              {cancelTitle}
            </Button>

            <Button color={popperType === ConfirmationPopperType.DEFAULT ? 'danger' : 'primary'} size='sm' loading={loading} onClick={onConfirm}>
              {confirmTitle}
            </Button>
          </div>
        </div>
      </div>
    </ClickAwayListener>
  </Popper>
);

export default ConfirmationPopper;
